import {DESKTOP_CONTENT_SIDE_PADDING} from '@constant/system';

/* eslint-disable max-len */
const sidePadding = 15;
const sectionStyle = {
  padding: [0, sidePadding],
};
const buttonHeight = 30;
const dividerOffset = 30;
export const headerHeight = 111;

const desktop = theme => {
  const {toVW} = theme;
  return {
    assetDivider: {
      '&.ant-divider-horizontal': {
        margin: `0px -${DESKTOP_CONTENT_SIDE_PADDING - dividerOffset}px 15px !important`,
        width: `calc(100% + ${(DESKTOP_CONTENT_SIDE_PADDING - dividerOffset) * 2}px)`,
      },
    },
  };
};

const mobile = theme => {
  return {
    modalSpin: {
      display: 'block',
      textAlign: 'center',
    },
    modalTitle: {
      textAlign: 'center',
      width: '100%',
      display: 'block',
      marginBottom: '20px',
      fontWeight: '600',
    },
    announcementPopup: {
      fontWeight: 250,
      '& .ant-tabs': {
        color: 'white',
        height: '50vh',
      },
      '& .ant-tabs-tab': {
        whiteSpace: 'pre-wrap',
        textAlign: 'left !important',
        padding: '2px 10px !important',
      },
      '& .ant-tabs-left >.ant-tabs-nav': {
        width: '30%',
      },
      '& .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn': {
        color: '#fff0b2',
      },
      '& .ant-tabs-ink-bar': {
        backgroundColor: '#F3B331',
      },
      '& .ant-tabs-tab:hover': {
        color: '#cfcfcf',
      },
      '& .ant-tabs-content-holder': {
        overflowY: 'auto',
        borderColor: '#ffffff30',
      },
      '& .ant-tabs-content': {
        backdropFilter: 'blur(5px)',
        whiteSpace: 'pre-wrap',
      },
    },
    header: {
      height: 'fit-content',
      padding: '0px',
      background: '#202633',
      width: '100%',
      position: 'fixed',
      top: 0,
    },
    hidden: {
      visibility: 'hidden',
    },
    displayAssetsRow: {
      height: 110,
    },
    assetDivider: {
      '&.ant-divider-horizontal': {
        margin: [[0, 0, 0], '!important'],
      },
    },
    buttonRow: {
      background: '#202633',
      height: 60,
      padding: [0, 12],
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    buttonRowWithJoinRoom: {
      extend: 'buttonRow',
      height: '62px',
    },
    language: {
      marginLeft: 10,
    },
    user: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      alignItems: 'center',
    },
    menuInDrawer: {
      color: 'white',
      fontSize: '17px',
      '&.ant-menu.ant-menu-dark': {
        background: theme.backgroundColor,
      },
    },
    buttonSection: {
      marginLeft: '15px',
      marginRight: '27px',
      display: 'flex',
      justifyContent: 'space-between',
    },
    searchBar: {
      // width: '85%',
      // margin: '20px auto',
      '--border-radius': '3px',
      '--background': '#96979D',
      '& .adm-search-bar-input-box': {},
    },
    searchBarBorderContainer: {
      background:
        'linear-gradient(155.28deg, #CC7DCC 0%, #0B0910 33.33%, #0B0910 66.67%, #632D92 100%)',
      boxShadow: ' 0px 0px 5px 0px #CD7DCC80',
      padding: 1,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: 'fit-content',
      height: 'fit-content',
      margin: '15px 15px',
      borderRadius: '5px',
      '& .adm-input-element': {
        color: '#ffffff',
      },
      '& .adm-search-bar-active .adm-search-bar-input-box': {
        borderColor: 'transparent',
        background:
          'linear-gradient(155.28deg, #CC7DCC 0%, #0B0910 33.33%, #0B0910 66.67%, #632D92 100%)',
        boxShadow: ' 0px 0px 5px 0px #CD7DCC80',
      },
    },

    navigationSection: {
      '& ul > li': {
        paddingLeft: '26px !important',
      },
      flex: '0 1 0',
    },
    upperPartSection: {
      extend: sectionStyle,
      flex: '0 0 174px',
    },
    userProfileSection: {
      marginBottom: 15,
    },
    indentedSectionsContainer: {
      extend: sectionStyle,
      flex: '0 0 40%',
      display: 'flex',
      flexDirection: 'column',
    },
    quickAccessSection: {
      extend: sectionStyle,
      marginTop: 78,
      '& a': {
        color: '#FFFFFF',
      },
      '& ul': {
        listStyleType: 'none',
        paddingInlineStart: 0,
        '& > li:not(:last-child)': {
          marginBottom: 10,
        },
      },
    },
    languageSelectorSection: {
      extend: sectionStyle,
      marginTop: 10,
    },
    languageSelector: {
      minWidth: 140,
      height: 40,
      width: '100%',
    },
    languageIcon: {
      marginRight: 10,
      width: '15px !important',
      height: '15px !important',
      fontSize: '20px',
    },
    footerSection: {
      extend: [sectionStyle, 'quickAccessSection'],
      marginTop: 30,
      '& a': {
        color: theme.secondaryTextColor,
      },
    },
    footerButton: {
      padding: 0,
      height: 'unset',
      color: theme.secondaryTextColor,
      fontSize: 14,
      marginBottom: 10,
      '&:hover': {
        cursor: 'pointer',
        color: 'rgba(255,255,255,0.75)',
      },
    },
    asideContentContainer: {
      // marginTop: 107,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'middle',
      background: theme.backgroundColor,
      height: '100vh',
    },
    upperPartWrapper: {
      marginTop: 72,
    },
    siderButtonRow: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: 10,
    },
    siderButton: {
      width: '100%',
      height: 40,
    },
    drawer: {
      '@global': {
        '.ant-drawer-body': {
          padding: 0,
        },
        '.ant-drawer-close': {
          marginTop: 40,
        },
      },
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      height: '100%',
    },
    customDropdown: {
      padding: 0,
      borderRadius: 5,
      boxShadow:
        'inset 0px 1px 0px rgba(189, 189, 189, 0.35), inset 0px 0px 4px rgba(118, 118, 118, 0.32)',
      left: '20px !important',
      background: '#2C3238',
      '& .ant-select-item': {
        color: 'white',
        fontSize: '16px',
        borderBottom: '1px solid #616569',
        '&.ant-select-item-option-selected:not(.ant-select-item-option-disabled)': {
          backgroundColor: 'transparent',
        },
        '&.ant-select-item-option-active:not(.ant-select-item-option-disabled)': {
          backgroundColor: 'transparent',
        },
        '&.ant-select-item-option:hover': {
          backgroundColor: '#555a60',
        },
      },
    },
    closeButton: {
      background: 'transparent',
      border: 'none',
      margin: '0 10px 10px auto',
    },
    closeIcon: {
      fontSize: 25,
    },
    menuButton: {
      padding: 0,
      marginRight: 12,
      height: 'fit-content',
      lineHeight: '0px',
    },
    menuButtonEnd: {extend: 'menuButton', marginRight: 0},
    hamburger: {
      fontSize: '14px',
      // marginTop: 11,
    },
    iconButton: {
      extend: 'hamburger',
      fontSize: '20px',
    },
    hamburgerAndLogoContainer: {
      display: 'flex',
      alignItems: 'center',
      height: '30px',
    },
    centerColumn: {
      display: 'flex',
      justifyContent: 'center',
      '& > a': {
        transition: 'none',
        opacity: 1,
      },
    },
    rightColumn: {
      display: 'flex',
      justifyContent: 'flex-end',
      height: 'fit-content',
    },
    logo: {
      transform: 'translateY(15px)',
      zIndex: '99',
      position: 'relative',
      height: '62px',
    },
    goldDecoRow: {
      height: '20px',
      width: '100%',
    },
    goldLine: {
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      height: '31px',
      width: '100%',
    },

    menuItem: {
      margin: 0,
      borderRadius: 0,
      '& .ant-menu-title-content': {
        display: 'flex',
        alignItems: 'center',
        '& > span:not(:last-child)': {
          marginLeft: 10,
        },
      },
      '&.ant-menu-item, &.ant-menu-vertical.ant-menu-item:not(:last-child)': {
        margin: '0px',
        height: 50,
        display: 'flex',
      },
      '&.ant-menu-item-selected': {
        '&:before': {
          content: '""',
          borderRadius: '0px 5px 6px 0px',
          background: 'linear-gradient(90deg, #33C4E8 0%, #4A65F2 100%)',
          position: 'absolute',
          top: 0,
          left: 0,
          width: 5,
          height: '100%',
        },
        backgroundColor: theme.backgroundColor,
        '& $menuText': {
          background: 'linear-gradient(180deg, #33C4E8 0%, #4A65F2 100%)',
          backgroundClip: 'text',
          '-webkit-text-fill-color': 'transparent',
        },

        '& svg': {
          '& path': {
            fill: 'url(#home_svg__paint0_linear_9_5855) !important',
            opacity: 1,
          },
        },
      },

      '&.ant-menu-item': {
        background: [theme.backgroundColor, '!important'],
        '& $menuText': {
          color: 'rgba(255, 255, 255, 0.5)',
        },

        '& .anticon': {
          display: 'block',
        },
        '& svg': {
          fontSize: 30,
          '& path': {
            fill: 'rgba(255, 255, 255, 1)',
          },
        },
        '&:hover:not(.ant-menu-item-selected)': {
          background: theme.backgroundColor,
          '& span': {
            '& a': {
              color: 'rgba(255, 255, 255, 0.65)',
            },
          },
        },
      },
      '& a': {
        display: 'flex',
        alignItems: 'center',
      },
    },
    menuIcon: {
      minWidth: 24,
      width: 30,
      height: 30,
      // marginRight: 10,
    },
    menuText: {
      color: theme.textColor,
      fontSize: 16,
      fontWeight: 500,
    },
    moneyAmountColumn: {
      display: 'flex',
      alignItems: 'center',
    },
    cyberPoker: {
      height: '30px',
      marginLeft: '1rem',
    },
    modalBodyTitle: {
      color: 'white',
      fontSize: 16,
    },
    modalBodyContent: {
      fontSize: 12,
      paddingInlineStart: '1em',
    },
    potButton: {
      minWidth: 60,
      height: buttonHeight,
      background: 'rgba(0, 0, 0, 0.25)',
      boxShadow: 'inset 0px 1px 4px 1px rgba(255, 255, 255, 0.4)',
      border: 'none',
      borderRadius: '10px',
      width: '15vw',
      color: theme.textColor,
      '&.ant-btn:hover': {
        background: 'rgba(0, 0, 0, 0.25)',
        boxShadow: 'inset 0px 1px 4px 1px rgba(255, 255, 255, 0.4)',
        border: 'none',
        color: theme.textColor,
      },
      '&.ant-btn:focus, &.ant-btn:active': {
        background: 'rgba(255, 255, 255, 0.25)',
        border: ' 1px solid #FFFFFF',
        boxShadow: '0px 0px 2px 1px #FFFFFF',
        color: theme.textColor,
      },
    },
    multiTableButtonContainer: {
      display: 'flex',
      gap: '5px',
      flex: 1,
      '&.hidden': {
        visibility: 'hidden',
      },
    },

    loginModalTitle: {
      color: 'white',
      display: 'block',
      margin: 'auto',
      width: 'fit-content',
      marginBottom: 10,
      fontSize: 14,
      fontWeight: '600',
    },
    loginMethodContainer: {display: 'flex', justifyContent: 'space-between'},
    loginButton: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      marginTop: 10,
      fontWeight: 200,
      height: 30,
      width: 80,
      background:
        'linear-gradient(349.13deg, #2C3238 5.84%, #303336 33.9%, #171717 61.97%, #4D5358 90.03%);',
      // boxShadow: '0px 3px 3px #000000BE',
      borderRadius: '5px',
      border: 'none',
      color: theme.textColor,
      fontSize: 12,
      lineHeight: '11px',
      textAlign: 'center',
      '&.ant-btn:hover, &.ant-btn:focus, &.ant-btn:active, &.ant-btn[disabled]': {
        background:
          // eslint-disable-next-line max-len
          'linear-gradient(349.13deg, #2C3238 5.84%, #303336 33.9%, #171717 61.97%, #4D5358 90.03%);',
        filter: 'brightness(0.7)',
        border: 'none',
        color: theme.textColor,
      },
    },
    connectButton: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      padding: '0px 5px',
      height: 40,
      // * to accommodate for min 360px width
      maxWidth: 155,
      color: 'white',
      border: 'none',
      borderRadius: '10px',
      background:
        'linear-gradient(90deg, rgba(255, 255, 255, 0.05) 0%, rgba(153, 153, 153, 0.05) 100%)',
      boxShadow:
        '-5px -5px 10px 0px rgba(255, 255, 255, 0.05), 5px 5px 10px 0px rgba(0, 0, 0, 0.25), 1px 1px 1px 0px rgba(255, 255, 255, 0.10) inset',
      '&.ant-btn': {
        '&:hover, &:focus, &:active, &[disabled]': {
          background:
            'linear-gradient(90deg, rgba(255, 255, 255, 0.05) 0%, rgba(153, 153, 153, 0.05) 100%)',
          border: 'none',
          color: 'white',
        },
      },
    },
    walletIcon: {
      cursor: 'pointer',
    },
    assetsRowDivider: {
      border: '0.1px solid white',
      width: '95%',
      margin: 'auto',
      opacity: 0.1,
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
